import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

export default function PopOver({ header, content, children }) {
  return (
    <OverlayTrigger
      trigger="click"
      rootClose={true}
      placement={"top"}
      overlay={
        <Popover>
          {header && <Popover.Header className="text-center" as="h3">{header}</Popover.Header>}
          <Popover.Body className="row justify-content-center align-items-center">
            {content}
          </Popover.Body>
        </Popover>
      }
    >
      {children}
    </OverlayTrigger>
  )
}